import { logger } from '../log';

export const statePrefix = 'missions2';
export const firebaseAppName = statePrefix;

export const log = logger('missions');
